import { css } from "@emotion/css";
import Tooltip from "../presentational/tooltip/tooltip";
import iconQuestion from "@img/shop/question-bundle.svg";
import colors from "@v2/styles/colors";
import { desktopDown, mobileOnly } from "@v2/styles/breakpoints";

const styles = css({
  borderRadius: 5,
  backgroundColor: "#FFF5E8",
  fontSize: 10,
  fontStyle: "normal",
  fontWeight: 500,
  lineHeight: "normal",
  letterSpacing: 0.1,
  padding: 5,
  position: "absolute",
  top: 10,
  left: 10,
  zIndex: 1,
  maxWidth: 120,

  '.tooltip': {
    position: 'relative',
    cursor: 'pointer',

    '.ing-tooltip': {
        [desktopDown]: {
            maxWidth: 150,
        },
        [mobileOnly]: {
          maxWidth: 120,
        },
        p: {
            color: `${colors.NAVY} !important`
        }
    }
  },
  '.tooltip-copy': {
    marginRight: 20,
  },

  img: {
    width: 16,
    height: 16,
    right: 0,
    position: 'absolute',
  },
});

export default function Discontinuation({ productId, style }: { productId: Number, style?: any }) {
  return (
    <>
      {['444', '441', '326992', '326972', '326019', '326892'].includes(String(productId)) ? (
        <div className={styles} style={style ? style : {}}>
          <Tooltip
            width={310}
            className="tooltip"
            description={`We're making room for exciting new products!`}
          >
            <span className="tooltip-copy">
            Leaving Soon!
            </span>
            <img loading="lazy" src={iconQuestion} alt="Question Mark" />
          </Tooltip>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}
